/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Create_Company_User_TitleInputs */

const en_admin_create_company_user_title = /** @type {(inputs: Admin_Create_Company_User_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add user to company`)
};

const de_admin_create_company_user_title = /** @type {(inputs: Admin_Create_Company_User_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer zu Unternehmen hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add user to company" |
*
* @param {Admin_Create_Company_User_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_create_company_user_title = /** @type {((inputs?: Admin_Create_Company_User_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Create_Company_User_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_create_company_user_title(inputs)
	return en_admin_create_company_user_title(inputs)
});